import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';
import type {
    CommentMarkAsReadMutation,
    CommentMarkAsReadMutationVariables,
} from 'generated/graphql';
import { CommentMarkAsReadDocument } from 'generated/graphql';

export const COMMENT_MARK_AS_READ_API_ROUTE =
    '/remix-api/app/build-hub-comment-mark-as-read';

export const action: ActionFunction = async ({ request, context }) => {
    const formData = await request.formData();
    const documentID = formData.get('documentID');

    if (!documentID || typeof documentID !== 'string') {
        return json({ error: 'Document ID is required' }, { status: 400 });
    }

    try {
        const { data } = await context.client.mutate<
            CommentMarkAsReadMutation,
            CommentMarkAsReadMutationVariables
        >({
            mutation: CommentMarkAsReadDocument,
            variables: { DocumentID: documentID },
        });

        return json(data);
    } catch (error) {
        console.error('Error marking comment as read:', error);
        return json({ error: 'Failed to mark as read' }, { status: 500 });
    }
};
